const cache = new Map();

export const cachedGet = async (key, requestFn) => {
  if (cache.has(key)) {
    return cache.get(key);
  }

  const data = await requestFn();
  cache.set(key, data);
  return data;
};
